
import CircleEmpty from "../../../assets/duotone/CircleEmpty.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CircleEmptyIcon({ className, dataTestid = "CircleEmptyIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <CircleEmpty data-testid={dataTestid} className={classes} {...rest} />
  );
}
